<template>
    <div class="login-container content">
      <img @click="navigateTo('index')" class="logo" :src="logoImg">
      <div class="login-container">
        <div class="userName">
          <div>
            <img src="../assets/userName1.png">
            <img src="../assets/userName2.png">
          </div>
          <input :class="language==='zh-CN' ? 'input' : 'input on'" v-model="userName" :placeholder="language==='zh-CN' ? '请输入账号名' : 'Please enter your name'" type="text">
        </div>
        <div class="password">
          <div>
            <img src="../assets/passWord.png">
          </div>
          <input :class="language==='zh-CN' ? 'input' : 'input on'" v-model="passWord" :placeholder="language==='zh-CN' ? '请输入密码' : 'Please enter your password'" type="password">
        </div>
        <div @click="login" class="btn" v-text="language==='zh-CN' ? '登录' : 'Log In'"></div>
      </div>
      <footerContainer></footerContainer>
    </div>
</template>
<script>
import footer from '../components/footer'

export default {
  components: {
      "footerContainer": footer
  },
  data() {
      return {
        language: 'zh-CN',
        userName: '',
        passWord: '',
        sourceUrl: '',
        logoImg: ''
      }
  },
  methods: {
    getConfig() { // 获取通用信息
        var that = this;
        require('../utils.js').requestWithToken({
            url: require('../config.json').urlBase + require('../config.json').url.user.getConfig,
            success: function(res) {
              if(res.code==='10000'){
                that.dailyEvent_ZH = res.result.dailyevents_url.zh_url;
                that.dailyEvent_EN = res.result.dailyevents_url.en_url;
                that.logoImg = res.result.logo;
              }else{
                if(that.$message==='zh-CN'){
                  that.$message({
                      type: 'warning',
                      message: res.error.message.zh_msg
                  })
                }else{
                  that.$message({
                      type: 'warning',
                      message: res.error.message.en_msg
                  })
                }
              }
            },
            error: function() {
                if(that.language==='zh-CN'){
                    that.$message({
                        type: 'error',
                        message: '网络错误'
                    })
                }else{
                    that.$message({
                        type: 'error',
                        message: 'Network Error'
                    })
                }
            }
        })
    },
    navigateTo(res) { // 跳转
      this.$router.push({
          name: res
      })
    },
    login() { // 登录
      var that = this;
      require('../utils.js').requestWithToken({
        url: require('../config.json').urlBase + require('../config.json').url.user.login,
        data: {
          card: that.userName,
          six: that.passWord
        },
        success: function(res) {
          if(res.code==='10000'){
            if(res.result.uid!=''&&res.result.uid!=undefined&&res.result.uid!=null&&res.result.unid!=''&&res.result.unid!=undefined&&res.result.unid!=null&&res.result.name!=''&&res.result.name!=undefined&&res.result.name!=null){
              localStorage.setItem("name", res.result.name); // 本地存储用户名
              localStorage.setItem("uid", res.result.uid); // 本地存储用户uid
              localStorage.setItem("unid", res.result.unid); // 本地存储用户unid
              localStorage.setItem("role", res.result.role); // 本地存储用户角色
              if(that.sourceUrl==='collectionVideo'){
                that.$router.push({
                  name: 'collectionVideo',
                  params: {
                    id: that.$route.params.id
                  }
                })
              }else if(that.sourceUrl==='videoDetail'){
                that.$router.push({
                  name: 'videoDetail',
                  params: {
                    id: that.$route.params.id
                  }
                })
              }else{
                that.$router.push({ 
                  name: that.sourceUrl
                })
              }
              if(that.language==='zh-CN'){
                that.$message({
                  type: 'success',
                  message: '登录成功'
                })
              }else{
                that.$message({
                  type: 'success',
                  message: 'log in successfully'
                })
              }
            }
          }else{
            if(res.error!=undefined&&res.error!=null&&res.error!=''){
              if(that.language==='zh-CN'){
                that.$message({
                  type: 'warning',
                  message: res.error.message.zh_msg
                })
              }else{
                that.$message({
                  type: 'warning',
                  message: res.error.message.en_msg
                })
              }
            }
          }
        },
        error: function() {
          if(that.language==='zh-CN'){
            that.$message({
                type: 'error',
                message: '网络错误'
            })
          }else{
            that.$message({
                type: 'error',
                message: 'Network Error'
            })
          }
        }
      })
    },
    IsPC() { //是否是PC端使用判断
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                  "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
      return flag;
    }
  },
  mounted() {
    var that =  this;
    (function (doc, win) {

      "use strict";

      var docEl = doc.documentElement,

          resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',

          recalc = function () {

            var clientWidth = docEl.clientWidth;
            var clientHeight = docEl.clientHeight;

            if (!clientWidth) {

                return;
            }

            var height = $('#app').height();

            var isPc = that.IsPC();

            if(isPc){ //根据使用设备判断页面高度
              if(clientWidth<=1366&&clientHeight<=768){
                height = parseFloat(height);
                height = height + 90 + 'px';
                $('.login-container.content').css({
                  'height': height
                })
              }else{
                $('.login-container.content').css({
                  'height': height
                })
              }
            }else{
              $('.login-container.content').css({
                'height': height
              })
            }
          };

      recalc();

      if (!doc.addEventListener) {

          return;
      }
      win.addEventListener(resizeEvt, recalc, false);

      doc.addEventListener('DOMContentLoaded', recalc, false);

    })(document, window);
  },
  created() {
    var language = $.cookie('language');
    if(language!=''&&language!=null&&language!=undefined){
      this.$i18n.locale = language;
    }else{
      this.$i18n.locale = 'zh-CN';
    }
    // 获取传参的url地址登录成功后返回传参的url如为空返回index
    var sourceUrl = decodeURIComponent(this.$route.params.sourceUrl);
    if(sourceUrl!=''&&sourceUrl!=undefined&&sourceUrl!=null&&sourceUrl!='undefined'&&sourceUrl!='null'){
      this.sourceUrl = sourceUrl;
    }else{
      this.sourceUrl = 'index';
    }
    this.language = this.$i18n.locale;
    this.getConfig();
  }
}
</script>
<style scoped>
  .content {
    position: relative;
    width: 20.48rem;
    /* height: 20.48rem; */
    height: 100%;
    /* height: 13.48rem; */
    background: url('../assets/loginBg.png') no-repeat;
    background-position: top right;
    background-size: 19.04rem 12rem;
    background-color: #FFF;
    margin: 0px auto;
  }

  .content .logo {
    position: absolute;
    top: 2.99rem;
    left: 1.64rem;
    width: 6.4rem;
    height: 0.84rem;
    user-select: none;
    cursor: pointer;
  }

  .content .login-container {
    position: absolute;
    top: 5.79rem;
    left: 3.34rem;
  }

  .content .login-container .userName {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 7.6rem;
    height: 0.92rem;
    border-radius: 6px;
    box-sizing: border-box;
    background: #224bd2;
    margin-bottom: 0.38rem;
    padding-right: 0.18rem;
  }

  .content .login-container .userName div {
    position: relative;
    width: 1.01rem;
    height: 0.8rem;
    border-right: 0.02rem solid #355ddf;
    box-sizing: border-box;
  }

  .content .login-container .userName div img:nth-of-type(1) {
    position: absolute;
    width: 0.52rem;
    height: 0.42rem;
    top: 50%;
    left: 50%;
    margin-top: -0.26rem;
    margin-left: -0.21rem;
    user-select: none;
  }

  .content .login-container .userName div img:nth-of-type(2) {
    position: absolute;
    width: 0.39rem;
    height: 0.29rem;
    top: 50%;
    left: 50%;
    margin-top: -0.195rem;
    margin-left: -0.145rem;
    user-select: none;
  }

  .content .login-container .userName input {
    width: 100%;
    height: 0.8rem;
    outline: none;
    border: none;
    padding: 0px 0.18rem;
    box-sizing: border-box;
    font-size: 0.36rem;
    color: #FFF;
    background: #224bd2;
    margin-left: 0.09rem;
  }

  .content .login-container .password {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 7.6rem;
    height: 0.92rem;
    border-radius: 6px;
    box-sizing: border-box;
    background: #224bd2;
    padding-right: 0.18rem;
  }

  .content .login-container .password div {
    position: relative;
    width: 1.01rem;
    height: 0.8rem;
    border-right: 0.02rem solid #355ddf;
    box-sizing: border-box;
  }

  .content .login-container .password div img {
    position: absolute;
    width: 0.42rem;
    height: 0.5rem;
    top: 50%;
    left: 50%;
    margin-top: -0.25rem;
    margin-left: -0.21rem;
    user-select: none;
  }

  .content .login-container .password input {
    width: 100%;
    height: 0.8rem;
    outline: none;
    border: none;
    padding: 0px 0.18rem;
    box-sizing: border-box;
    font-size: 0.36rem;
    color: #FFF;
    background: #224bd2;
    margin-left: 0.09rem;
  }

  .content .login-container .btn {
    width: 2.6rem;
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: center;
    background: #236af4;
    font-size: 0.36rem;
    color: #FFF;
    border-radius: 40px;
    border: 0.04rem solid #cfddfd;
    box-sizing: border-box;
    cursor: pointer;
    margin: 0.48rem 0 0 5rem;
    user-select: none;
  }

  .content .login-container .btn:hover {
    border: 0.04rem solid #FFF;
    background: #2654eb;
  }

  .footer-container {
    position: absolute;
    bottom: 0px;
  }

  .input::-webkit-input-placeholder { /* WebKit browsers */
    color: #5e8df7;
  }

  .input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #5e8df7;
  }

  .input:-ms-input-placeholder { /* Internet Explorer 10+ */
    color: #5e8df7;
  }

  .input.on::-webkit-input-placeholder { /* WebKit browsers */
    font-size: 0.32rem;
    color: #5e8df7;
  }

  .input.on::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 0.32rem;
    color: #5e8df7;
  }

  .input.on:-ms-input-placeholder { /* Internet Explorer 10+ */
    font-size: 0.32rem;
    color: #5e8df7;
  }

  input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        background: transparent;
    }
</style>
